import VectorImageSdk from '../components/VectorImage/corvid/VectorImage.corvid';


const VectorImage = {
  sdk: VectorImageSdk
};


export const components = {
  ['VectorImage']: VectorImage
};

